import React, { ChangeEvent, Component } from 'react';
import { ColumnProps } from 'primereact/column';
import { RootState } from '../../../../../redux/store';
import { changeApiVariable, changeApiVariableParameter } from '../../../../../redux/actions/ApiVariableActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { customConfirm } from '../../../../custom/CustomPopupConfirm';
import { ApiVariableParameter } from '../../../../../domain/remote/httpVariable/HttpVariableDomains';
import CustomInput from '../../../../custom/CustomInput';
import CustomTable from '../../../../custom/CustomTable';
import { ApiVariableState } from 'redux/reducers/ApiVariableReducer';
import RoleHelper from '../../../../../RoleHelper';
import Icon from '../../../../../icons/Icon';
import EmptyComponent from '../../../../custom/empty-components/EmptyComponent';
import ComponentName from '../../../../../constant/ComponentName';
import LanguageUtil from '../../../../../util/LanguageUtil';

class ApiParametersListComponent extends Component<Props> {
  public render() {
    const {
      apiVariable: { apiVariable },
    } = this.props;

    if (apiVariable.parameters?.length <= 0) return <EmptyComponent createDisabled={true} type={ComponentName.ENRICHMENT} />;

    return (
      <div className={'overflow-y-hidden lg:!max-h-[calc(100vh-28.625rem)] 2xl:!max-h-[calc(100vh-30rem)] rounded-lg'}>
        <CustomTable columns={this.getColumns()} value={apiVariable.parameters} />
      </div>
    );
  }

  private getColumns = (): ColumnProps[] => {
    return [
      {
        field: 'isActive',
        header: LanguageUtil.get({ id: 'pages.enrichment.apiEnrichment.parameters.table.active', defaultMessage: 'Active' }),
        className: 'max-w-[10%]',
        body: (variableParameter: ApiVariableParameter) => (
          <div className={'flex items-center justify-center'}>
            <input
              type={'checkbox'}
              className={'accent-f-purple text-white w-4 h-4 border-[1px] border-[#EAECF0] bg-white'}
              disabled={!RoleHelper.canEdit('EnrichmentApi')}
              onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeActive(e, variableParameter)}
              checked={variableParameter.isActive}
              data-testid={`${ComponentName.API_VARIABLE}_parameter_active_checkbox_${variableParameter.key}`}
            />
          </div>
        ),
      },
      {
        field: 'key',
        header: LanguageUtil.get({ id: 'pages.enrichment.apiEnrichment.parameters.table.key', defaultMessage: 'Key' }),
        className: 'min-w-[30%]',
        body: (variableParameter: ApiVariableParameter) => (
          <CustomInput
            inputType={'ghost'}
            type={'text'}
            disabled={!RoleHelper.canEdit('EnrichmentApi')}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeKey(e, variableParameter)}
            value={variableParameter.key}
            data-testid={`${ComponentName.API_VARIABLE}_parameter_key_input_${variableParameter.key}`}
          />
        ),
      },
      {
        field: 'value',
        header: LanguageUtil.get({ id: 'pages.enrichment.apiEnrichment.parameters.table.value', defaultMessage: 'Value' }),
        className: 'min-w-[25%]',
        body: (variableParameter: ApiVariableParameter) => (
          <CustomInput
            inputType={'ghost'}
            type={'text'}
            disabled={!RoleHelper.canEdit('EnrichmentApi')}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeValue(e, variableParameter)}
            value={variableParameter.value}
            data-testid={`${ComponentName.API_VARIABLE}_parameter_value_input_${variableParameter.key}`}
          />
        ),
      },
      {
        field: 'description',
        header: LanguageUtil.get({ id: 'pages.enrichment.apiEnrichment.parameters.table.description', defaultMessage: 'Description' }),
        className: 'min-w-[28%]',
        body: (variableParameter: ApiVariableParameter) => (
          <CustomInput
            inputType={'ghost'}
            type={'text'}
            disabled={!RoleHelper.canEdit('EnrichmentApi')}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeDescription(e, variableParameter)}
            value={variableParameter.description}
            data-testid={`${ComponentName.API_VARIABLE}_parameter_description_input_${variableParameter.key}`}
          />
        ),
      },
      {
        className: 'max-w-[10%]',
        alignHeader: 'center',
        header: LanguageUtil.get({ id: 'pages.enrichment.apiEnrichment.parameters.table.action', defaultMessage: 'action' }),
        sortable: false,
        body: (variableParameter: ApiVariableParameter) => (
          <div
            className={'flex w-full items-center justify-center'}
            onClick={(e: any) => {
              e.stopPropagation();
              e.preventDefault();
              RoleHelper.canEdit('EnrichmentApi') &&
                customConfirm({
                  target: e.currentTarget,
                  accept: () => this.deleteApiVariableParameter(variableParameter),
                  message: LanguageUtil.get({ id: 'messages.confirm.removeVariable', defaultMessage: 'Are you sure remove this variable?' }),
                });
            }}
            data-testid={`${ComponentName.API_VARIABLE}_parameter_remove_button_${variableParameter.key}`}
          >
            <Icon
              icon={'delete'}
              size={20}
              color={'primary'}
              className={'hover:text-primary text-[#607080]  hover:cursor-pointer flex items-center justify-center'}
            />
          </div>
        ),
      },
    ];
  };

  private onChangeActive = (e: ChangeEvent<HTMLInputElement>, variableParameter: ApiVariableParameter) => {
    const {
      apiVariable: { apiVariable },
      changeApiVariable,
      changeApiVariableParameter,
    } = this.props;
    variableParameter.isActive = e.target.checked;
    changeApiVariableParameter(apiVariable);
    changeApiVariable(apiVariable);
  };

  private onChangeKey = (e: ChangeEvent<HTMLInputElement>, variableParameter: ApiVariableParameter) => {
    const {
      changeApiVariable,
      apiVariable: { apiVariable },
      changeApiVariableParameter,
    } = this.props;
    variableParameter.key = e.currentTarget.value;
    changeApiVariableParameter(apiVariable);
    changeApiVariable(apiVariable);
  };

  private onChangeValue = (e: ChangeEvent<HTMLInputElement>, variableParameter: ApiVariableParameter) => {
    const {
      changeApiVariable,
      apiVariable: { apiVariable },
      changeApiVariableParameter,
    } = this.props;
    const regex = /[?&]([^=#]+)=([^&#]*)/g;
    let variables = apiVariable.url.split(regex);
    variables = variables.filter((item) => item != '');
    variables.shift();
    variableParameter.value = e.currentTarget.value;
    changeApiVariableParameter(apiVariable);
    changeApiVariable(apiVariable);
  };
  private onChangeDescription = (e: ChangeEvent<HTMLInputElement>, variableParameter: ApiVariableParameter) => {
    const {
      changeApiVariable,
      apiVariable: { apiVariable },
    } = this.props;
    variableParameter.description = e.currentTarget.value;
    changeApiVariable(apiVariable);
  };

  private deleteApiVariableParameter = (parameter: ApiVariableParameter) => {
    const {
      apiVariable: { apiVariable },
      changeApiVariable,
    } = this.props;
    apiVariable.parameters = apiVariable.parameters.filter((p: ApiVariableParameter) => p.key != parameter.key);
    changeApiVariable(apiVariable);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  apiVariable: state.apiVariable as ApiVariableState,
  isUpdate: state.apiVariable.isUpdate,
});

const mapDispatchToProps = { changeApiVariable, changeApiVariableParameter };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ApiParametersListComponent);
